import React from "react";

interface OrchyLogoProps {
  size?: number;
  className?: string;
}

export const OrchyLogo: React.FC<OrchyLogoProps> = ({ size = 26, className = "" }) => (
  <img
    src="/orchy-logo.svg"
    width={size}
    height={size}
    alt=""
    aria-hidden="true"
    className={className}
    style={{ display: "inline-block" }}
  />
);
